var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:['btn', _vm.type, {readonly:_vm.boolReadonly}],attrs:{"href":"javascript:void(0)","disabled":_vm.boolDisabled},on:{"click":_vm.toggle}},[_c('span',{class:['glyphicon','glyphicon-'+(_vm.value?'ok':'remove')]}),_vm._v(" "),_vm._t("default"),_vm._v(" "),(_vm.name)?_c('input',{attrs:{"type":"hidden","name":_vm.name},domProps:{"value":_vm.active?1:0}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-194a9619","hasScoped":false,"buble":{"transforms":{}}}!./src/togglebutton/template.html
// module id = 203
// module chunks = 0